import Parameter, { ParameterList } from '@/models/api/payment/parameter/parameter'
import { SelectOptionList } from '@/models/api/payment/parameter/type/user-select'
import { Payment as ApiPayment } from '@/models/api/payment/payment'
import OptionsValidator, { ErrorBag } from '@/services/payment/options-validator'
import { PaymentMethod } from '@spa/store/modules/orderHistory/types'
import { Either, Left, Right } from 'fp-ts/lib/Either'

export default class CreateSelectOptionList {

  static default(): CreateSelectOptionList {
    return new CreateSelectOptionList(
      (parameters: ParameterList<Parameter>, selectedOptions: SelectOptionList) =>
        (new OptionsValidator(parameters, selectedOptions)).validate()
    )
  }

  constructor(
    private readonly validate: (parameters: ParameterList<Parameter>, selectedOptions: SelectOptionList) => ErrorBag
  ) {}

  fromPaymentMethod(
    paymentMethod: Omit<PaymentMethod, 'kind'>,
    apiPayment: ApiPayment
  ): Either<Error, SelectOptionList> {
    const selectedOptionList = apiPayment.parameters.onlyUserSelect.list.reduce(
      (optionList, userSelect) => {
        const lastValue = paymentMethod[userSelect.id]
        if (!lastValue) {
          return optionList
        }

        const selectOption = userSelect.options.find(option => option.id === lastValue)
        if (!selectOption) {
          return optionList
        }

        return optionList.add(selectOption)
      },
      SelectOptionList.empty()
    )

    if (this.validate(apiPayment.parameters, selectedOptionList).hasSomeError) {
      return new Left(new Error('SelectOptions in the purchase is invalid.'))
    }

    return new Right(selectedOptionList)
  }
}
